import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6389d819"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"content\" data-v-6389d819><div class=\"item\" data-v-6389d819><div class=\"item-left\" data-v-6389d819><span class=\"item-title\" data-v-6389d819>极加服务</span><span class=\"item-number\" data-v-6389d819>设备序列号：77998432422</span><span class=\"item-time fix-margin-top-12\" data-v-6389d819>生效时间：2021.04.05 00:00</span><span class=\"item-time\" data-v-6389d819>到期时间：2021.04.05 23:59</span></div><div class=\"item-right\" data-v-6389d819><span class=\"item-tag\" data-v-6389d819>保障中</span></div></div></div>", 1)

import AppHeader from '@/components/Header.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'period',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "极加服务" }),
    _hoisted_1
  ], 64))
}
}

})